//writes / update admin data to the user tables
import { useFetchJson } from "../hooks/useFetchJson";
import Loading from "../Loading";
import { useEffect, useState } from "react";

export default function UserUpdate({data, old, token, onSuccess, onError}){

    let url = "api/user/";
    let dataStruct;
    let method = "";
    const today = new Date().toISOString().slice(0,10);
    ///alert(JSON.stringify(data.adminEmail))
    let isActive = false;
    
    if(data.isActive === 'checked' || data.isActive === true){
       isActive = true;
    }
    
    if(data.userId !== undefined){
        url += data.userId;
        method = "PUT";
        dataStruct = {
            "userId" : data.adminEmail,
            "reason" : data.notes,
            "originalUser": old.userDetails,
            "userDetails": {
                "siBadgeNum": data.siBadgeNum,
                "securityQuestion": data.securityQuestion,
                "securityAnswer": data.securityAnswer,
                "roles": [],
                    "searchPreference": {
                    "country": data.prCountry,
                    "state": data.prState,
                    "query": data.prQuery
                },
                "officeTypeId": data.officeTypeId,
                "active": isActive,
                "orgCoordEmail": data.orgCoordEmail,
                "userName":{
                    "firstName": data.firstName,
                    "lastName": data.lastName,
                    "middleName": data.middleName
                },
                "phone": null,
                "orgCoordinator": data.orgCoordinator,
                "organization": data.organization,
                "userEmail": data.userEmail,
                "jobCategoryId": data.jobCategoryId,
                "state": data.state,
                "category": "CDLIS",
            },
            "lastAccessed": today,
            "active": isActive,
            "created": data.created,
            "updated": data.updated,
            "disabledDate": null
        }
    } else {
        method = "POST";
        dataStruct = {
            "userId" : data.adminEmail,
            "reason" : data.notes,
            "userDetails": {
                "siBadgeNum": data.siBadgeNum,
                "securityQuestion": data.securityQuestion,
                "securityAnswer": data.securityAnswer,
                "roles": [],
                    "searchPreference": {
                    "country": data.prCountry,
                    "state": data.prState,
                    "query": data.prQuery
                },
                "officeTypeId": data.officeTypeId,
                "active": isActive,
                "orgCoordEmail": data.orgCoordEmail,
                "userName":{
                    "firstName": data.firstName,
                    "lastName": data.lastName,
                    "middleName": data.middleName
                },
                "phone": null,
                "orgCoordinator": data.orgCoordinator,
                "organization": data.organization,
                "userEmail": data.userEmail,
                "lastAccessed": data.lastAccessed,  //check and remove
                "jobCategoryId": data.jobCategoryId,
                "state": data.state,
                "category": "CDLIS"
            },
            "lastAccessed": data.lastAccessed, //remove this one.
            "active": isActive,  //standarize with the other active
            "created": data.created,
            "updated": data.updated,
            "disabledDate": null
        }
    }

    if(data.hascdlisUser === 'checked' || data.hascdlisUser === true){
        dataStruct.userDetails.roles.push('cdlisUsr');
    }

    if(data.hascdlisAdmin === 'checked' || data.hascdlisAdmin === true){
        dataStruct.userDetails.roles.push('cdlisAdmin');
    }

    if(data.hasMinimalDrivReq === 'checked' || data.hasMinimalDrivReq === true){
        dataStruct.userDetails.roles.push('minimalDrivReq');
    }

    if(data.hasFcwd === 'checked' || data.hasFcwd === true){
        dataStruct.userDetails.roles.push('fcwdState');
    }

    if(data.hasFcwdTechSupp === 'checked' || data.hasFcwdTechSupp === true){
        dataStruct.userDetails.roles.push('fcwdTechSupp');
    }

    if(data.hasTechSupp === 'checked' || data.hasTechSupp === true){
        dataStruct.userDetails.roles.push('techSupp');
    }

    if(data.hasMxSearch === 'checked' || data.hasMxSearch === true){
        dataStruct.userDetails.roles.push('searchMx');
    }

    if(data.hasCnSearch === 'checked' || data.hasCnSearch === true){
        dataStruct.userDetails.roles.push('searchCn');
    }

    if(data.hasCdlisFcwdOnly === 'checked' || data.hasCdlisFcwdOnly === true){
        dataStruct.userDetails.roles.push('cdlisFcwdOnly');
    }

    if(data.hasBatch === 'checked' || data.hasBatch === true){
        dataStruct.userDetails.roles.push('batch');
    }

    if(data.hasHelpDesk === 'checked' || data.hasHelpDesk === true){
        dataStruct.userDetails.roles.push('fcwdHelpDesk');
    }

    console.log(JSON.stringify(dataStruct))
    //alert(JSON.stringify(dataStruct))
    // const res = useFetchJson(url, dataStruct, method, token);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const performUpdate = async () => {
            try {
                const res = await fetch(url, {
                    method: method,
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(dataStruct),
                    credentials: 'include',
                });

                const ans = await res.json();

                // Check for HTTP errors OR a logical success: false flag
                if (!res.ok || ans.success === false) {
                    // Trigger the error callback to the parent form immediately
                    if (onError) onError(ans.message || "An error occurred while saving.");
                } else {
                    // Trigger the success callback
                    if (onSuccess) onSuccess(method);
                }
            } catch (err) {
                // Catch hard network errors
                if (onError) onError(err.message || "Network connection failed.");
            } finally {
                setLoading(false);
            }
        };

        performUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    while(loading){
        //return(<h4>Inserting / Updating...</h4>)
        return(<Loading />)
    }

    return null;
}
